<template>
  <section>
    <AboutHeader />
    <AboutIntro />
    <AboutBullets />
    <AboutPromote />
    <AboutTeam />
    <AboutCharte />
    <AboutHistory />
    <NavigationCta />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'About',
  components: { ...partials },
  provide() {
    return {
      wp: this.$wp.pages.about || {}
    }
  }
}
</script>
